import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.JobSummary = {
  displayName: 'JobSummary',
  validator: '',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    onStepProgression()
  },

  onLeftNavButtonClick(onStepProgression) {
    $('#job-modal').data('bootstrapValidator').removeField('site_visit')

    if (Job.Data.siteVisit === 'weekdays' || Job.Data.siteVisit === 'weekends') {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SiteVisitTime)
    }
    else {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.ChooseSiteVisit)
    }
  },

  buttonLayout: function() {
    return 'upButton'
  },

  component: React.createClass({
    componentDidMount: function() {
      Job.Actions.updateBackToSubmit(false)
    },

    handleLinkClick: function(componentName) {
      Job.Actions.updateBackToSubmit(true)
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', componentName)
    },

    renderLink: function(linkLabel, componentName){
      return (
        <a href="#"
           className="text-blue pl4"
           onClick={() => this.handleLinkClick(componentName)}>{linkLabel}
           <i className="ficon-arrow-down pl4"/>
        </a>
      )
    },

    renderFirstName: function() {
      return ` ${SS.currentUserName || Job.Data.firstName}`
    },

    renderSchedule: function() {
      let schedule = ''
      if (Job.Data.scheduleDate !== "") {
        schedule = Job.Data.scheduleDate
      }
      else {
        switch (Job.Data.schedule) {
          case 'this_week':
            schedule = 'This week'
            break;
          case 'next_couple_of_weeks':
            schedule = 'In the next few weeks'
            break;
          case 'asap_urgent':
            schedule = 'Urgent'
            break;
          case 'flexible':
            schedule = 'I’m flexible'
            break;
          default:
            schedule = 'On a Particular Date'
        }
      }

      return this.renderLink(schedule, JobWizardMobile.ChooseSchedule)
    },

    renderBudget: function() {
      let budget = ''

      if (Job.Data.budgetInMind === "no") {
        budget = "No"
      }
      else {
        budget = Job.Data.budgetPriceRange !== null ? this.renderPriceRange() : Job.Data.budgetSetPriceRange
      }

      return this.renderLink(budget, JobWizardMobile.ChooseBudget)
    },

    renderPriceRange: function() {
      let range = ''
      if (Job.Data.minBudget == '5001' && Job.Data.maxBudget == '5001') {
        range = 'More than $5000'
      } else {
        range = `$${Job.Data.minBudget} - $${Job.Data.maxBudget}`
      }

      return range
    },

    renderSiteVisit: function() {
      let siteVisit = ''
      if (Job.Data.siteVisit === "no_site_visit_required") {
        siteVisit = "no site visit"
      }
      else {
        siteVisit = Job.Data.siteVisit
      }

      return this.renderLink(siteVisit, JobWizardMobile.ChooseSiteVisit)
    },

    render() {
      return (
        <div>
          <h3 className="mb15 mt20">Submit your job</h3>
          <div className="form-group">
            <div className="input-group p5 details-mobile">
              <p>
                Hi
                {this.renderFirstName()},
              </p>
              <p>Let's see if we got this right:</p>
              <p>You need quotes for
                {this.renderLink(Job.Data.category, JobWizardMobile.SelectCategory)}
                 in
                {this.renderLink(Job.Data.suburb, JobWizardMobile.SelectLocation)}
              </p>
              <p>You said</p>
              <p>
                {this.renderLink(Job.Data.description, JobWizardMobile.EnterDescription)}
              </p>
              <p>You attached
                <a href="#"
                   className="text-blue pl4"
                   onClick={() => this.handleLinkClick(JobWizardMobile.AddAttachment)}>{Job.Data.fileNames.length} photo/s
                   <i className="ficon-arrow-down pl4"/>
                </a>
              </p>
              <p>Schedule?
                {this.renderSchedule()}
              </p>
              <p>Budget?
                {this.renderBudget()}
              </p>
              <p>Site Visit?
                {this.renderSiteVisit()}
              </p>
            </div>
          </div>
          <div className="pb24">
            By pressing 'Submit' you agree to receive lead alerts and marketing messages by email & SMS and to our <a className='no-wrap' href='https://www.serviceseeking.com.au/blog/terms-and-conditions/' target='_blank'>Terms & Conditions</a>
          </div>
          <JobWizardMobile.NavigationButtons
            navButtonLayout='submitButton'
            onStepProgression={this.props.onStepProgression}
          />
        </div>
      )
    }
  })
}
